
























































import { Component, Vue, Watch } from "vue-property-decorator";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
import QualificationDto from "@/models/Qualifications/QualificationDto";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import WorkerQualificationDto from "@/models/WorkerQualifications/WorkerQualificationDto";
import CreateWorkerQualificationRequest from "@/models/WorkerQualifications/CreateWorkerQualificationRequest";
import WorkerQualificationStatus from '@/models/WorkerQualifications/WorkerQualificationStatus';

@Component({
  name: "WorkerQualificationCreate",
})
export default class extends GiganautVueDialog {
  public dialog = false;
  qualification: QualificationDto = new QualificationDto();
  isVerified = false;

 @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.qualification = new QualificationDto();
      this.isVerified = false;
    }
  }
  
  get qualifications() {
    return WorkerDetailsModule.agencyAttributes.qualifications;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateWorkerQualificationRequest();
    request.qualificationId = this.qualification.id;
    if (this.isVerified){
        request.status = WorkerQualificationStatus.Verified;
    } else {
        request.status = WorkerQualificationStatus.Pending;
    }
    request.source = 1; // Manual
    await WorkerDetailsModule.createQualification(request);
    this.dialog = false;
  }
}
